import { Injectable } from '@angular/core';
var BrowserUtil = (function () {
    function BrowserUtil() {
    }
    BrowserUtil.prototype.isIE11 = function () {
        return navigator.appName === 'Netscape' && navigator.appVersion.indexOf('Trident') !== -1;
    };
    return BrowserUtil;
}());
export { BrowserUtil };
BrowserUtil.decorators = [
    { type: Injectable },
];
/** @nocollapse */
BrowserUtil.ctorParameters = function () { return []; };
//# sourceMappingURL=browser-util.service.js.map